import React, { useState } from 'react';
import fisioImage from '../../src/assets/logo.png';

const FisioHeader = ({ setCurrentPage }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleNavigation = (page) => {
    setCurrentPage(page);
    setIsMobileMenuOpen(false); // Cierra el menú móvil al navegar
  };

  return (
    <header className="w-full bg-white shadow-sm fixed top-0 left-0 z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <button onClick={() => handleNavigation('home')} className="flex items-center focus:outline-none">
          <img src={fisioImage} 
          alt="Fisio Life Logo" className="h-8 w-8 mr-3" />
          <span className="text-2xl font-bold text-gray-800">Fisio Life</span>
        </button>
        <nav className="hidden md:flex space-x-8">
          <button onClick={() => handleNavigation('home')} className="text-gray-600 hover:text-blue-600 transition-colors text-lg font-medium">Inicio</button>
          <button onClick={() => handleNavigation('services')} className="text-gray-600 hover:text-blue-600 transition-colors text-lg font-medium">Servicios</button>
          <button onClick={() => handleNavigation('about')} className="text-gray-600 hover:text-blue-600 transition-colors text-lg font-medium">Nosotros</button>
          <button onClick={() => handleNavigation('schedule')} className="text-gray-600 hover:text-blue-600 transition-colors text-lg font-medium">Horario</button>
          <button onClick={() => handleNavigation('contact')} className="text-gray-600 hover:text-blue-600 transition-colors text-lg font-medium">Contacto</button>
        </nav>
        <div className="md:hidden">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-600 hover:text-blue-600 focus:outline-none">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg py-4">
          <nav className="flex flex-col items-center space-y-4">
            <button onClick={() => handleNavigation('home')} className="text-gray-800 hover:text-blue-600 transition-colors text-lg font-medium w-full py-2">Inicio</button>
            <button onClick={() => handleNavigation('services')} className="text-gray-800 hover:text-blue-600 transition-colors text-lg font-medium w-full py-2">Servicios</button>
            <button onClick={() => handleNavigation('about')} className="text-gray-800 hover:text-blue-600 transition-colors text-lg font-medium w-full py-2">Nosotros</button>
            <button onClick={() => handleNavigation('schedule')} className="text-gray-800 hover:text-blue-600 transition-colors text-lg font-medium w-full py-2">Horario</button>
            <button onClick={() => handleNavigation('contact')} className="text-gray-800 hover:text-blue-600 transition-colors text-lg font-medium w-full py-2">Contacto</button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default FisioHeader;